import React from 'react'
import * as dates from '../../../utils/dates'
import moment from 'moment'
import { Calendar, momentLocalizer, Views } from 'react-big-calendar'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { DataContext } from '../../../state/DataContext/DataContext';
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, ScaleFade, Text } from '@chakra-ui/react';
import { JobCard } from '../../Admin/AdminJob/JobCard/JobCard';
import { RBCToolbar } from './RBCToolbar';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useParams } from 'react-router-dom';
import { firestore } from '../../../utils/firebase';
import { Job } from '../../../typings/Job';

const localizer = momentLocalizer(moment)
let allViews = Object.keys(Views).map(k => Views[k])

const ColoredDateCellWrapper = ({ children }) =>
    React.cloneElement(React.Children.only(children), {
        style: {
            backgroundColor: 'white',
        },
    })
const now = new Date()

const getJobScheduleAsEvents = (JobData) => {
    let JobEvents = []
    JobEvents = JobData?.docs?.map(result => {
        let job: Job = result.data();
        return {
            job: job,
            jobID: job?.ID,
            title: job?.Title,
            customerName: job?.CustomerName,
            allDay: false,
            start: new Date(job.StartDateTime.toDate()),
            end: new Date(job.EndDateTime.toDate()),
        }
    })

    return JobEvents

}

const CalendarComponent = () => {

    const { data, actions } = React.useContext(DataContext);
    const [isModalVisible, setIsModalVisible] = React.useState(false);
    const [currentJob, setCurrentJob] = React.useState({});
    const [view, setView] = React.useState("month");
    const [date, setDate] = React.useState(now);

    const { tenantID } = useParams<any>();

    const [value, loading, error] = useCollection(
        firestore.collection(`tenants/${tenantID}/jobs`).where("TenantID", "==", tenantID),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );


    const onSelectSlot = (slotInfo) => {
        console.log("isArray", Array.isArray(slotInfo))
        if (!Array.isArray(slotInfo)) {
            setView("day")
            setDate(new Date(slotInfo.start))
        }
        else {
            setView("day")
            setDate(new Date(slotInfo[0].start))
        }

    };

    return <>
        {!loading &&
            <Calendar
                events={getJobScheduleAsEvents(value)}
                views={allViews}
                onView={(view) => {
                    setView(view)
                }}
                onNavigate={(date, view, action) => {
                    if (view === "agenda" && action === "NEXT") {
                        date = moment(date).add(1, "day").toDate();
                    }
                    setDate(date);
                }}
                view={view}
                step={60}
                selectable
                // defaultDate={now}
                popup
                date={date}
                showMultiDayTimes
                max={dates.add(dates.endOf(new Date(2021, 3, 1), 'day'), -1, 'hours')}
                components={{
                    timeSlotWrapper: ColoredDateCellWrapper,
                    toolbar: RBCToolbar
                }}
                onSelectSlot={onSelectSlot}
                onSelectEvent={event => {
                    console.log(event)
                    if (event.job) {
                        setCurrentJob(event.job)
                    }
                    // console.log(value.docs.filter(doc => doc.data().JobID === event.jobID))
                    setIsModalVisible(true)
                }}
                onShowMore={onSelectSlot}

                localizer={localizer}
            />
        }
        <Modal isCentered isOpen={isModalVisible} size="2xl" onClose={() => setIsModalVisible(false)}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader
                >
                    {/* // <Text borderLeftWidth="3px"
                    //     borderColor="green.500"
                    //     paddingLeft="4"
                    // >
                    //     {currentJob.title}

                    // </Text> */}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <JobCard noShadow job={currentJob} onClose={() => setIsModalVisible(false)} />
                </ModalBody>
                <ModalFooter></ModalFooter>
            </ModalContent>
        </Modal>
    </>
}

export default CalendarComponent
